import { createRoot } from 'react-dom/client';
// Inter (variable), la misma tipografía que sporttia-competitions
import '@fontsource-variable/inter';
import '@fontsource/geist-mono/100.css';
import '@fontsource/geist-mono/200.css';
import '@fontsource/geist-mono/300.css';
import '@fontsource/geist-mono/400.css';
import '@fontsource/geist-mono/500.css';
import '@fontsource/geist-mono/600.css';
import '@fontsource/geist-mono/700.css';
import '@fontsource/geist-mono/800.css';
import '@fontsource/geist-mono/900.css';
import 'flag-icons/css/flag-icons.min.css';
import './index.css';
import * as serviceWorker from './serviceWorker';
import App from './App';
import './i18n';
import { setDateLocale } from './lib/dateLocale';
import { initContentWidth } from './layout/settings/useContentWidth';

// Apply font classes to body
document.body.className = 'font-sans';

// Set date-fns in Spanish by default
setDateLocale('es');

// Ancho de contenido guardado en ajustes -> <html data-content-width>
initContentWidth();

const container = document.getElementById('root');
const root = createRoot(container!);
root.render(<App />);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
